import React from 'react';
import './index.scss';
const SiriusCheckbox = ({ disabled = false, checked = false, styles }) => {
    const checkedClass = checked ? 'checked' : '';
    const checkClassName = disabled ? 'disabled' : checkedClass;
    return React.createElement("div", { className: `sirius-checkbox ${checkClassName}`, style: styles });
};
export default SiriusCheckbox;
